import { render } from "./OfferingUpdates.vue?vue&type=template&id=08cbce8e"
import script from "./OfferingUpdates.vue?vue&type=script&lang=js"
export * from "./OfferingUpdates.vue?vue&type=script&lang=js"
script.render = render

export default script